import React, { useState } from 'react';
import './SEOMetricCard.css';
import { getScoreColorClass } from 'utils/scoreColors';
import { useTranslation } from 'react-i18next';
import ScoreInfoButton from '../../ScoreInfoButton/ScoreInfoButton';

const SEOMetricCard = ({
  title,
  score,
  infoTooltip = 'Information sur cette métrique',
  initialExpanded = false,
  showDivider = true,
  expanded: controlledExpanded,
  onToggle,
  children,
}) => {
  const [internalExpanded, setInternalExpanded] = useState(initialExpanded);
  const { t } = useTranslation();
  const isControlled = typeof controlledExpanded === 'boolean';
  const expanded = isControlled ? controlledExpanded : internalExpanded;
  // Format score with comma as decimal separator (French format)
  const formattedScore = score.toString().replace('.', ',');

  // Toggle expanded state
  const toggleExpanded = () => {
    if (isControlled) {
      if (typeof onToggle === 'function') onToggle();
      return;
    }
    setInternalExpanded(!expanded);
  };

  return (
    <div className={`seo-metric-card ${expanded ? 'expanded' : 'collapsed'}`}>
      {/* Header - Always visible */}
      <div className="seo-metric-header" onClick={toggleExpanded}>
        <div className="seo-metric-title">
          {title}
          <ScoreInfoButton
            text={t(infoTooltip)}
            onClick={(e) => e.stopPropagation()}
          />
        </div>

        <div className="seo-metric-score-container">
          <div className={`seo-metric-score ${getScoreColorClass(score)}`}>
            {formattedScore}%
          </div>

          <button
            className="toggle-button"
            onClick={(e) => {
              e.stopPropagation(); // Not needed since parent has same handler, but good practice
              toggleExpanded();
            }}
            aria-label={expanded ? 'Collapse' : 'Expand'}
          >
            {expanded ? '−' : '+'}
          </button>
        </div>
      </div>

      {/* Content - Only visible when expanded */}
      {expanded && (
        <div className="seo-metric-content">
          {showDivider && <hr className="seo-metric-divider" />}
          {children}
        </div>
      )}
    </div>
  );
};

export default SEOMetricCard;
